<template>
  <div>
    <div class="echart clear">
      <div class="lft">
        <ul>
          <li v-for="(item, index) in price" :key="index">${{ item }}</li>
        </ul>
      </div>
      <div class="rgt">
        <div class="top">
          <div class="lines">
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
          </div>
          <div class="bars clear">
            <div
              v-for="(item, index) in date.slice().reverse()"
              :key="index"
              class="bar"
              @mouseout="outEvt"
              @mouseover="hoverEvt(index)"
            >
              <div :style="{ height: item.all + 'px' }" class="box"></div>
              <div
                v-if="item.bonus"
                :style="{ height: item.bonus + 'px', bottom: item.all + 'px' }"
                class="grnBox"
              >
                <span v-if="curShow == index" :style="{ top: '-50px' }"></span>
              </div>
              <div
                v-if="curShow == index"
                :style="{ height: '12px', bottom: item.all + 6 + 'px' }"
                class="nums"
              >
                <div class="inn">${{ item.nums }}</div>
              </div>
            </div>
          </div>
          <div class="svg">
            <svg height="238" version="1.1" width="760">
              <path
                v-for="(item, index) in allHeight"
                :key="index"
                :d="item"
                fill="#F5F4F7"
                stroke="#F5F4F7"
                stroke-linecap="round"
                stroke-width="1"
              ></path>
            </svg>
          </div>
        </div>
        <div class="btm">
          <ul class="clear">
            <li v-for="(item, index) in date.slice().reverse()" :key="index">
              {{ item.month }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      curShow: -1
    };
  },
  props: {
    barsHeight: {
      type: Array,
      default: () => {
        return [];
      }
    },
    date: {
      type: Array,
      default: () => {
        return [];
      }
    },
    price: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  computed: {
    allHeight() {
      var that = this;
      var path = [];
      that.barsHeight.reverse().forEach((v, i) => {
        var center;
        var line;
        if (this.barsHeight[i + 1] > this.barsHeight[i]) {
          center =
            this.barsHeight[i] +
            Math.abs(parseInt((this.barsHeight[i + 1] - v) / 2));
          center = 237 - center;
        } else {
          center =
            this.barsHeight[i + 1] +
            Math.abs(parseInt((this.barsHeight[i + 1] - v) / 2));
          center = 237 - center;
        }
        if (i == 0 && this.barsHeight[1]) {
          if (this.barsHeight[i + 1] > this.barsHeight[i])
            line = `M36,237 L36,${237 - v} C60,${center} 50,${center} 80,${237 -
              this.barsHeight[i + 1]}, L80,237`;
          else
            line = `M36,237 L36,${237 - v} C70,${center} 50,${center} 80,${237 -
              this.barsHeight[i + 1]}, L80,237`;
          path.push(line);
        }
        if (i == 1 && this.barsHeight[2]) {
          if (this.barsHeight[i + 1] > this.barsHeight[i])
            line = `M94,237 L94,${237 -
              v} C119,${center} 109,${center} 139,${237 -
              this.barsHeight[i + 1]}, L139,237`;
          else
            line = `M94,237 L94,${237 -
              v} C129,${center} 109,${center} 139,${237 -
              this.barsHeight[i + 1]}, L139,237`;
          path.push(line);
        }
        if (i == 2 && this.barsHeight[3]) {
          if (this.barsHeight[i + 1] > this.barsHeight[i])
            line = `M152,237 L152,${237 -
              v} C175,${center} 165,${center} 195,${237 -
              this.barsHeight[i + 1]}, L195,237`;
          else
            line = `M152,237 L152,${237 -
              v} C185,${center} 165,${center} 195,${237 -
              this.barsHeight[i + 1]}, L195,237`;
          path.push(line);
        }
        if (i == 3 && this.barsHeight[4]) {
          if (this.barsHeight[i + 1] > this.barsHeight[i])
            line = `M210,237 L210,${237 -
              v} C233,${center} 223,${center} 254,${237 -
              this.barsHeight[i + 1]}, L254,237`;
          else
            line = `M210,237 L210,${237 -
              v} C243,${center} 223,${center} 254,${237 -
              this.barsHeight[i + 1]}, L254,237`;
          path.push(line);
        }
        if (i == 4 && this.barsHeight[5]) {
          if (this.barsHeight[i + 1] > this.barsHeight[i])
            line = `M268,237 L268,${237 -
              v} C275,${center} 285,${center} 315,${237 -
              this.barsHeight[i + 1]}, L315,237`;
          else
            line = `M268,237 L268,${237 -
              v} C285,${center} 285,${center} 315,${237 -
              this.barsHeight[i + 1]}, L315,237`;
          path.push(line);
        }
        if (i == 5 && this.barsHeight[6]) {
          if (this.barsHeight[i + 1] > this.barsHeight[i])
            line = `M326,237 L326,${237 -
              v} C351,${center} 341,${center} 371,${237 -
              this.barsHeight[i + 1]}, L371,237`;
          else
            line = `M326,237 L326,${237 -
              v} C361,${center} 341,${center} 371,${237 -
              this.barsHeight[i + 1]}, L371,237`;
          path.push(line);
        }
        if (i == 6 && this.barsHeight[7]) {
          if (this.barsHeight[i + 1] > this.barsHeight[i])
            line = `M384,237 L384,${237 -
              v} C411,${center} 401,${center} 431,${237 -
              this.barsHeight[i + 1]}, L431,237`;
          else
            line = `M384,237 L384,${237 -
              v} C421,${center} 401,${center} 431,${237 -
              this.barsHeight[i + 1]}, L431,237`;
          path.push(line);
        }
        if (i == 7 && this.barsHeight[8]) {
          if (this.barsHeight[i + 1] > this.barsHeight[i])
            line = `M442,237 L442,${237 -
              v} C465,${center} 455,${center} 486,${237 -
              this.barsHeight[i + 1]}, L486,237`;
          else
            line = `M442,237 L442,${237 -
              v} C475,${center} 455,${center} 486,${237 -
              this.barsHeight[i + 1]}, L486,237`;
          path.push(line);
        }
        if (i == 8 && this.barsHeight[9]) {
          if (this.barsHeight[i + 1] > this.barsHeight[i])
            line = `M500,237 L500,${237 -
              v} C523,${center} 509,${center} 541,${237 -
              this.barsHeight[i + 1]}, L541,237`;
          else
            line = `M500,237 L500,${237 -
              v} C533,${center} 509,${center} 541,${237 -
              this.barsHeight[i + 1]}, L541,237`;
          path.push(line);
        }
        if (i == 9 && this.barsHeight[10]) {
          if (this.barsHeight[i + 1] > this.barsHeight[i])
            line = `M558,237 L558,${237 -
              v} C581,${center} 563,${center} 606,${237 -
              this.barsHeight[i + 1]}, L606,237`;
          else
            line = `M558,237 L558,${237 -
              v} C601,${center} 563,${center} 606,${237 -
              this.barsHeight[i + 1]}, L606,237`;
          path.push(line);
        }
        if (i == 10 && this.barsHeight[11]) {
          if (this.barsHeight[i + 1] > this.barsHeight[i])
            line = `M616,237 L616,${237 -
              v} C639,${center} 617,${center} 671,${237 -
              this.barsHeight[i + 1]}, L671,237`;
          else
            line = `M616,237 L616,${237 -
              v} C649,${center} 617,${center} 671,${237 -
              this.barsHeight[i + 1]}, L671,237`;
          path.push(line);
        }
        if (i == 11 && this.barsHeight[12]) {
          if (this.barsHeight[i + 1] > this.barsHeight[i])
            line = `M674,237 L674,${237 -
              v} C679,${center} 691,${center} 726,${237 -
              this.barsHeight[i + 1]}, L726,237`;
          else
            line = `M674,237 L674,${237 -
              v} C689,${center} 691,${center} 726,${237 -
              this.barsHeight[i + 1]}, L726,237`;
          path.push(line);
        }
      });
      return path;
    }
  },
  methods: {
    hoverEvt(e) {
      this.curShow = e;
    },
    outEvt() {
      this.curShow = -1;
    }
  }
};
</script>

<style lang="scss" scoped>
.echart {
  width: 100%;
  height: 320px;
  margin-bottom: 0.8rem;
  display: flex;
  overflow: hidden;

  .lft {
    flex: 0 0 auto;
    margin-right: 0.1rem;
    padding-top: 40px;

    li {
      font-size: 14px;
      line-height: 17px;
      margin-bottom: 16px;
      color: #3f3f46;
    }
  }

  .rgt {
    flex: 1;
    overflow-x: auto;
    padding-top: 40px;

    .top {
      width: 760px;
      height: 238px;
      box-sizing: border-box;
      border-left: 1px solid #dee3e0;
      border-bottom: 1px solid #dee3e0;
      position: relative;
      margin-bottom: 15px;

      .lines {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        z-index: 1;
        width: 760px;

        .line {
          position: absolute;
          left: 0;
          width: 100%;
          border-top: 1px solid #dee3e0;
        }

        .line:nth-child(1) {
          top: 7px;
        }

        .line:nth-child(2) {
          top: 40px;
        }

        .line:nth-child(3) {
          top: 73px;
        }

        .line:nth-child(4) {
          top: 106px;
          height: 1px;
        }

        .line:nth-child(5) {
          top: 139px;
        }

        .line:nth-child(6) {
          top: 172px;
        }

        .line:nth-child(7) {
          top: 205px;
        }
      }

      .bars {
        white-space: nowrap;

        .bar {
          width: 58px;
          height: 238px;
          z-index: 2;
          display: inline-block;
          position: relative;

          .box {
            width: 16px;
            background: rgba(63, 63, 70, 1);
            border-radius: 3px 3px 0px 0px;
            position: absolute;
            left: 21px;
            bottom: 0;
            border-radius: 3px 3px 0px 0px;
            z-index: 2;
          }

          .grnBox {
            width: 16px;
            background: #2cca73;
            border-radius: 3px 3px 0px 0px;
            position: absolute;
            left: 21px;

            span {
              display: block;
              position: absolute;
              left: -21px;
              width: 58px;
              height: 45px;
              background-size: contain;
              background-position: center center;
              background-repeat: no-repeat;
              background-image: url("../../assets/bonus.png");
            }
          }

          .nums {
            width: 16px;
            position: absolute;
            left: 21px;

            .inn {
              text-align: center;
              font-size: 12px;
              color: #3f3f46;
              font-family: ProximaNova-Semibold;
              width: 100px;
              position: absolute;
              left: -42px;
              top: 0;
            }
          }
        }
      }

      .svg {
        position: absolute;
        left: 0;
        top: 0;
        height: 238px;
        width: 100%;
      }
    }

    .btm {
      width: 760px;
      box-sizing: border-box;

      li {
        float: left;
        width: 58px;
        text-align: center;
        font-size: 14px;
        padding-top: 1.5px;
        color: #3f3f46;

        span {
          display: block;
          color: #a3a1a4;
          margin-top: 6px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/package/barSecondChart.vue